import { useReducer, useState } from "react";
import { DialogActions, DialogContent, TextField, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { DialogTitle } from "@mui/material";
import { Grid } from "@mui/material";
import { MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "@mui/material";
import { pos_create } from "../../../../../../controllers/company/cashless/PosController";
import QUDProgress from "../../../../../../components/progress";
import ResponseComponent from "../../../../../../components/responseComponent";
import { participant_create } from "../../../../../../controllers/company/cashless/ParticipantsController";


const initialState = {
    name:'',    errorName:false,
    type:'',    errorType: false,
    email:'',   errorEmail: false,
    pin:'',     errorPin: false,

    isLoading: false,

    open: false,
    title: '',
    message: '',
    success: false
}
  
function reducer( state, { field, value })
{
    return{
        ...state,
        [field] : value
    }
}

export default function CashlessEconomyParticipantsCreate({economy,onUpdate})
{
    const [openDialog,setOpenOpenDialog] = useState(false);
    const [state,setState] = useReducer(reducer,initialState);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const {
        name, type, email,
        errorName, errorType, errorEmail,
        pin, errorPin,
        isLoading,
        
        open,
        title,
        message,
        success
    } = state;

    const onChange = (e) => {
        setState({field : e.target.name, value : e.target.value});
    }

    const handleToggleDialogForm = () => {
        setOpenOpenDialog(!openDialog);
    }

    const handleClose = () => {
        setState({field: 'email', value: ''});
        setState({field: 'errorEmail', value: false});

        handleToggleDialogForm();
    }

    const handleSubmit = async () => {
        setState({field:'isLoading',value: true});

        const response = await participant_create(economy.uuid,email);

        if(response.success === true)
        {
            setState({field:'title',value:'Operación Exitosa'});
            setState({field:'message',value:response.message.message});
            setState({field:'success',value:true});
            setState({field:'open',value:true});
        }
        else
        {
            setState({field:'title',value:'Operación Fallida'});
            setState({field:'message',value:response.message.message});
            setState({field:'success',value:false});
            setState({field:'open',value:true});
        }

        setState({field:'isLoading',value: false});
    }

    const onClose = () => {
        setState({field:'open',value:false});
        handleClose();
        onUpdate();
    }
    
    return(
        <>
            <Button variant="contained" onClick={()=>handleToggleDialogForm()}>
                <Typography>Registrar Participante</Typography>
            </Button>

            <Dialog
                open={openDialog}
                onClose={()=>handleClose()}
                fullScreen={fullScreen}
                maxWidth='md'
            >
                <DialogTitle id="responsive-dialog-title">
                    Crear POS
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={()=>handleClose()}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <FontAwesomeIcon icon={faClose}/>
                </IconButton>
                <DialogContent>
                    <Grid container spacing={3}>
                        {/**merchant email */}
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TextField
                                fullWidth
                                label='Email del participante'
                                name='email'
                                id='email'
                                required
                                value={email}
                                onChange = { onChange }
                                onBlur={ () => setState({field:'errorEmail',value:email === ''}) }
                                error = {errorEmail}
                                helperText={errorEmail && <Typography>Ingrese el nombre de la economia</Typography>}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{pr:3}}>
                    <Button onClick={()=>handleToggleDialogForm()}>
                        <Typography>Cancelar</Typography>
                    </Button>
                    <Button variant="contained" onClick={()=>handleSubmit()}>
                        <Typography>Registrar Participante</Typography>
                    </Button>
                </DialogActions>
            </Dialog>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>onClose()}
                //secondaryText={'No'}
                ///secondaryAction={()=>history.push('/categories')}
            />
        </>
    )
}